<template>
    <AppLayout>
        <div class="max-w-7xl mx-auto px-4 py-6">
            <!-- Page Title -->
            <div class="mb-6 space-y-2">
                <h1 class="text-2xl md:text-3xl font-bold text-gray-800 dark:text-white">
                    {{ $tc('LBL_NOTIFICATION', 2) }}
                </h1>
                <!-- Breadcrumb -->
                <nav
                    class="text-sm text-gray-500 mb-6"
                    aria-label="Breadcrumb"
                >
                    <ol class="flex items-center space-x-2">
                        <li class="flex items-center">
                            <inertia-link
                                :href="route('landing')"
                                class="text-green-600 hover:underline"
                            >
                                {{ $t('LBL_HOME') }}
                            </inertia-link>
                            <svg
                                class="w-3 h-3 mx-2 text-green-400"
                                fill="currentColor"
                                viewBox="0 0 320 512"
                            >
                                <path
                                    d="M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z"
                                />
                            </svg>
                        </li>
                        <li class="text-gray-600 dark:text-gray-300">
                            {{ $tc('LBL_NOTIFICATION', 1) }}
                        </li>
                    </ol>
                </nav>
            </div>
            <!-- breadcrumb end -->

            <!-- Controls -->
            <div class="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 mb-4">
                <div class="flex gap-2 items-center w-full md:w-auto">
                    <t-select
                        v-model="filterType"
                        :options="filterTypeOptions"
                        text-attribute="label"
                        value-attribute="value"
                        @change="filterNotifications"
                        variant="success"
                        class="border border-gray-300 dark:border-gray-600 rounded pl-2 py-1.5 pr-10 text-sm dark:bg-gray-800 dark:text-white"
                    />
                </div>

                <t-button
                    variant="outline"
                    size="sm"
                    class="px-4 py-2"
                    @click="markAllAsRead"
                >
                    Mark all as read
                </t-button>
            </div>

            <!-- Notifications List -->
            <div class="space-y-4">
                <a
                    v-for="notification in notifications.data"
                    :key="notification.id"
                    :href="notification.data.link === '/' ? '#' : notification.data.link"
                    class="flex items-start gap-3 p-4 rounded-lg transition border shadow-sm cursor-pointer"
                    :class="[
                        notification.read_at
                            ? 'bg-white dark:bg-gray-800 border-gray-200 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-700'
                            : 'bg-green-50 dark:bg-green-900/30 border-green-300 hover:bg-green-100 dark:hover:bg-green-800/40',
                    ]"
                >
                    <img
                        class="w-10 h-10 rounded-full object-cover"
                        :src="notification.data.profilePhotoUrl"
                        alt="avatar"
                    />
                    <div class="flex flex-col justify-between flex-1 text-sm text-gray-800 dark:text-gray-200">
                        <p>{{ notification.data.message }}</p>
                        <span class="mt-1 text-xs text-blue-500 dark:text-blue-400 font-medium">
                            {{ notification.created_at | fromNow }}
                        </span>
                    </div>
                </a>
                <div
                    v-if="!this.notifications.data.length"
                    class="text-center px-4 py-4 text-gray-500 dark:text-gray-400"
                >
                    {{ $t('LBL_DATA_FOUND') }}
                </div>
            </div>
            <div
                class="flex justify-center items-center bg-gray-100 dark:bg-gray-800 mt-10 px-4 py-4 border-t dark:border-gray-700"
            >
                <t-pagination
                    v-model="currentPage"
                    variant="rounded"
                    :total-items="totalRows"
                    :per-page="perPage"
                    :limit="limit"
                    :disabled="!this.notifications.data.length"
                    @change="fetchPageData"
                />
            </div>
        </div>
    </AppLayout>
</template>

<script>
    import AppLayout from '@/Layouts/AppLayout.vue';

    export default {
        name: 'NotificationIndex',

        components: {
            AppLayout,
        },

        props: {
            notifications: {
                type: Object,
                required: true,
            },
            filters: Object,
        },

        data() {
            return {
                currentPage: 1,
                limit: 5,
                perPage: this.notifications.per_page,
                totalRows: this.notifications.total,
                filterType: this.filters?.type || '',
                filterTypeOptions: [
                    { value: '', label: 'All' },
                    { value: 'purchased', label: 'Order' },
                    { value: 'credit', label: 'Credit' },
                    { value: 'system', label: 'System' },
                ],
            };
        },

        created() {
            this.currentPage = this.notifications.current_page;
        },

        methods: {
            fetchPageData(newPage) {
                this.$inertia.get(
                    route('notifications.index', {
                        page: newPage,
                        type: this.filterType,
                    }),
                );
            },
            filterNotifications() {
                this.currentPage = 1;
                this.fetchPageData();
            },
            markAllAsRead() {
                this.$inertia.post(
                    route('notifications.markAllAsRead'),
                    {},
                    {
                        preserveScroll: true,
                        onSuccess: () => {
                            this.fetchPageData();
                        },
                    },
                );
            },
        },
    };
</script>
